import React from "react";
import "./Fivebox.css";

const Fivebox = () => {
  const items = [
    {
      title: "Beginner",
      // price: 2400,
      points: [
        "Build a strong foundation in everyday English",
        "Gain confidence in greetings, conversations, and social interactions",
        "Start speaking fluently in simple, real-life situations"
      ]
    },
    {
      title: "Intermediate",
      // price: 6000,
      points: [
        "Improve grammar, vocabulary, and sentence structure",
        "Learn to express thoughts clearly in personal and professional settings",
        "Develop listening and speaking skills for group discussions and meetings"
      ]
    },
    {
      title: "Advanced",
      // price: 7800,
      points: [
        "Master the art of professional communication",
        "Practice presentations, interviews, and public speaking",
        "Enhance your discussion skills in various situations"
      ]
    },
    {
      title: "TOEFL & IELTS Preparation",
      // price: 12300,
      points: [
        "Structured training to meet international test standards",
        "Learn strategies for reading, writing, speaking, and listening sections",
        "Prepare with confidence to achieve high scores and unlock global opportunities",
        "Module-wise training for Listening, Reading, Writing and Speaking. Students may choose any of the 4 modules as per their requirement",
        "Mock test is common to all students, includes all 4 modules"
      ]
    }
  ];

  return (
    <div className="fivebox-section">
      <h2 className="section-title">Our Programs Crafted for You - Where Your Goals and Journey Find the Right Path</h2>
      <p className="section-desc">
        At NewZeal Language Academy, every learner’s journey is unique — and so are our courses.  
        Whether you are a student aiming for academic excellence, a professional looking to grow in your career,  
        or a homemaker aiming to communicate confidently, our programs are designed for you.
      </p>
      <div className="fivebox-container">
        {items.map((item, index) => (
          <div key={index} className="fivebox-card fade-in">
            <h3>{item.title}</h3>
            {/* <p className="price">Fees: ₹{item.price}</p> */}
            <ul>
              {item.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div>
        <br /><br />
        <a className="join-btn mt-5" href="/course">Explore Our Course Content</a>
      </div>
    </div>
  );
};

export default Fivebox;
